import deepmerge from 'deepmerge';
import { getTenantPreLoginConfig } from '../teanantPreLoginConfig';
import { TENANTS_NAMES } from '../host_config';

const getLoginConfigDefault = () => {
  return {
    login: {
      isLoginEnabled: true,
      isFromLoginToSignUpEnabled: false,
    },
  };
};

const getSignUpConfigDefault = () => {
  return {
    signUp: {
      isSignUpEnabled: true,
      isFromSignUpToLoginEnabled: false,
    },
  };
};

const getConfigByTenant = () => {
  return {
    [TENANTS_NAMES.xpo]: {
      login: {
        isFromLoginToSignUpEnabled: true,
      },
      signUp: {
        isFromSignUpToLoginEnabled: true,
      },
    },
  };
};

const getSignUpConfig = (tenant) => {
  const defaultConfig = getSignUpConfigDefault();
  const configByTenant = getConfigByTenant();
  return deepmerge(defaultConfig, configByTenant[tenant] || {});
};

const getLoginConfig = (tenant) => {
  const defaultConfig = getLoginConfigDefault();
  const configByTenant = getConfigByTenant();
  return deepmerge(defaultConfig, configByTenant[tenant] || {});
};

const getBusinessConfig = (tenant) => {
  return {
    ...getSignUpConfig(tenant),
    ...getLoginConfig(tenant),
  };
};

const getCurrentTenantBusinessConfig = () => {
  const currentTenant = getTenantPreLoginConfig().tenant_name;
  return getBusinessConfig(currentTenant);
};

export { getBusinessConfig, getCurrentTenantBusinessConfig };
